import { render, staticRenderFns } from "./word-manager-form-vpc.vue?vue&type=template&id=1e78b061&scoped=true"
import script from "./word-manager-form-vpc.ts?vue&type=script&lang=ts&external"
export * from "./word-manager-form-vpc.ts?vue&type=script&lang=ts&external"
import style0 from "./word-manager-form-vpc.less?vue&type=style&index=0&id=1e78b061&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e78b061",
  null
  
)

export default component.exports